import { Flex, Heading, Stack } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface SectionPanelProps {
    title?: ReactNode;
    actions?: ReactNode;
    children: ReactNode;
}

const SectionPanel = ({ title, actions, children }: SectionPanelProps) => (
    <Stack as='section' gap='4' minW='0' borderWidth='1px' borderColor='border' bg='bg.panel' rounded='lg' p={{ base: 4, lg: 6 }}>
        {title && (
            <Flex justify='space-between' align='center' gap='4' wrap='wrap'>
                <Heading as='h2' size='lg'>{title}</Heading>
                {actions}
            </Flex>
        )}
        {children}
    </Stack>
);

export default SectionPanel;
